import React from "react";
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { MainMenuData, DaMenuItem } from '../../_appData/mainNavData';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogoLink } from './Header.styles';
import { useAuth } from '../../_auth/useAuth';

interface SidebarNavProps {
  open: boolean;
  onClose: () => void;
}

const SidebarNav: React.FC<SidebarNavProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userHasPrivilege, canNavigateState } = useAuth();

  /**
   * Check if a menu item should be visible based on user roles
   */
  const isItemVisible = (item: DaMenuItem): boolean => {
    // If no allowedRoles specified, item is visible to all authenticated users
    if (!item.allowedRoles || item.allowedRoles.length === 0) {
      return true;
    }
    // Check if user has at least one of the required roles
    return userHasPrivilege(item.allowedRoles);
  };

  return (
    <Drawer anchor="left" open={open} onClose={onClose}
      PaperProps={{ sx: { bgcolor: '#222', color: '#fff' } }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '12px 0 8px 0', background: 'inherit' }}>
        <LogoLink
          to="/"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            navigate("/");
            onClose();
          }}
          style={{ cursor: 'pointer' }}
        >
          <img src={require("../../../static/img/da_paf_manager_logo_256x32.png")} alt="PAF Manager - Data Axle" style={{ maxHeight: 24, width: 'auto' }} />
        </LogoLink>
      </div>
      <List sx={{ width: 250, bgcolor: 'transparent', height: '100%' }}>
        {canNavigateState && MainMenuData(userHasPrivilege)
          .filter((item) => isItemVisible(item))
          .map((item) => {
            const selected = location.pathname === item.path;
            return (
              <ListItem
                button
                key={item.label}
                onClick={() => { navigate(item.path); onClose(); }}
                sx={{
                  color: '#fff',
                  borderRadius: 1,
                  my: 0.5,
                  backgroundColor: selected ? 'rgba(255,255,255,0.12)' : 'transparent',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.18)',
                    color: '#fff',
                  },
                  fontWeight: selected ? 700 : 400,
                }}
                selected={selected}
              >
                <ListItemText primary={item.label} primaryTypographyProps={{ noWrap: true, sx: { color: '#fff' } }} />
              </ListItem>
            );
          })}
      </List>
    </Drawer>
  );
};

export default SidebarNav;
